<div [@routerTransition]>
    <div class="content d-flex flex-column flex-column-fluid">
        <div [class]="containerClass">
            <div class="card card-custom gutter-b">
                <div class="card-body">
                    <div class="row m-3">
                        <div class="col-12">
                            <h1 class="pb-4">{{ 'Legal' | localize }}</h1>
                            <h2 class="pb-4">{{ 'LegalDisclaimer' | localize }}</h2>
                            <p [innerHTML]="l('LegalDisclaimerContent')" class="pb-4"></p>
                            
                            <h2 class="pb-4">{{ 'LegalIntangibleRights' | localize }}</h2>
                            <p [innerHTML]="l('LegalIntangibleRightsContent')"></p>
                            <p class="pb-4"><a [routerLink]="['../imprint']">{{"Imprint" | localize}}</a></p>
                            
                            <h2 class="pb-4">{{ 'LegalPrivacyStatement' | localize }}</h2>
                            <p [innerHTML]="l('LegalPrivacyStatementContent')" class="pb-4"></p>
                            
                            <h2 class="pb-4">{{ 'LegalDataManipulation' | localize }}</h2>
                            <p [innerHTML]="l('LegalDataManipulationContent')"></p>
                            <div [innerHTML]="l('LegalDataManipulationTable')" class="pb-4"></div>
                            
                            <h2 class="pb-4">{{ 'LegalCookies' | localize }}</h2>
                            <p [innerHTML]="l('LegalCookiesContent')" class="pb-4"></p>
                            
                            <h2 class="pb-4">{{ 'LegalSocialMedia' | localize }}</h2>
                            <p [innerHTML]="l('LegalSocialMediaContent')" class="pb-4"></p>
                            
                            <h2 class="pb-4">{{ 'LegalContactForQuestions' | localize }}</h2>
                            <p [innerHTML]="l('LegalContactForQuestionsContent')"></p>
                            <p class="pb-4"><a [routerLink]="['../imprint']">{{"Imprint" | localize}}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
